import { Controller } from "@hotwired/stimulus"
import { Modal } from "./../utils/modal"

export default class extends Controller {
  static values = {
    activeTitle: String,
    inactiveTitle: String,

    activeMessage: String,
    inactiveMessage: String,

    activeConfirmText: String,
    inactiveConfirmText: String
  }

  toggleChanged(event) {
    const checked = event.target.checked;
    const title = checked ? this.activeTitleValue : this.inactiveTitleValue
    const message = checked ? this.activeMessageValue : this.inactiveMessageValue
    const confirmText = checked ? this.activeConfirmTextValue : this.inactiveConfirmTextValue

    Modal.danger({
      title: title,
      message: message,
      confirmText: confirmText,
      cancelText: window.I18n.general.cancel,
      onConfirm: () => {
        this.element.closest("form").requestSubmit()
      },
      onCancel: () => {
        this.element.closest("form").reset()
      }
    });
  }
}
